import { tsUtils } from '@neo-one/ts-utils';
export function getFixedDecimals(type) {
    const aliasTypes = tsUtils.type_.getAliasTypeArgumentsArray(type);
    if (aliasTypes.length === 1) {
        return aliasTypes[0].value;
    }
    return undefined;
}

//# sourceMappingURL=getFixedDecimals.js.map
